<template>
  <div class="bg-white p-3 rounded shadow-sm mb-3">
    <div class="row gy-2 gx-2 align-items-end">
      <div class="col-auto col-md-2">
        <label class="form-label">Start Date</label>
        <input
          v-model="localSdate"
          type="date"
          class="form-control form-control-sm"
        />
      </div>

      <div class="col-auto col-md-2">
        <label class="form-label">End Date</label>
        <input
          v-model="localEdate"
          type="date"
          class="form-control form-control-sm"
        />
      </div>

      <div class="col-auto col-md-2">
        <label class="form-label">Device</label>
        <select v-model="localDevice" class="form-select form-select-sm">
          <option value="0">All Devices</option>
          <option v-for="device in devices" :key="device.id" :value="device.id">
            {{ device.name }}
          </option>
        </select>
      </div>

      <div class="col-auto d-flex align-items-end gap-2">
        <button @click="emitUpdate" class="btn btn-warning btn-sm px-4">
          Apply
        </button>
      </div>
    </div>

    <div class="d-flex flex-wrap gap-3 mt-3">
      <div class="form-check form-switch d-flex align-items-center">
        <input
          v-model="localBwphotos"
          class="form-check-input"
          type="checkbox"
          id="bwphotos"
        />
        <label class="form-check-label ms-2" for="bwphotos">BW Photos</label>
      </div>

      <div class="form-check form-switch d-flex align-items-center">
        <input
          v-model="localColorphotos"
          class="form-check-input"
          type="checkbox"
          id="colorphotos"
        />
        <label class="form-check-label ms-2" for="colorphotos"
          >Colored Photos</label
        >
      </div>

      <div class="form-check form-switch d-flex align-items-center">
        <input
          :checked="localUp === 1"
          @change="localUp = $event.target.checked ? 1 : 0"
          class="form-check-input"
          type="checkbox"
          id="userPhotos"
        />
        <label class="form-check-label ms-2" for="userPhotos"
          >User Photos</label
        >
      </div>

      <div class="form-check form-switch d-flex align-items-center">
        <input
          :checked="localTp === 1"
          @change="localTp = $event.target.checked ? 1 : 0"
          class="form-check-input"
          type="checkbox"
          id="testPhotos"
        />
        <label class="form-check-label ms-2" for="testPhotos"
          >Test Photos</label
        >
      </div>
    </div>

    <div class="row">
      <div class="col-auto mt-3">
        <button
          class="btn btn-outline-secondary btn-sm px-4"
          type="button"
          @click="emitExport('xlsx')"
        >
          Export
        </button>
      </div>

      <div class="col-auto">
        <button
          class="btn btn-outline-secondary btn-sm px-4 mt-3"
          type="button"
          @click="emitExport('doc', 'ge')"
        >
          Export DOC (GE)
        </button>
      </div>

      <div class="col-auto">
        <button
          class="btn btn-outline-secondary btn-sm px-4 mt-3"
          type="button"
          @click="emitExport('doc', 'en')"
        >
          Export DOC (EN)
        </button>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "PhotoStatsHeader",
  props: {
    sdate: String,
    edate: String,
    bwphotos: Boolean,
    colorphotos: Boolean,
    up: Number,
    tp: Number,
    devices: Object,
  },
  data() {
    return {
      localSdate: this.sdate,
      localEdate: this.edate,
      localBwphotos: this.bwphotos,
      localColorphotos: this.colorphotos,
      localUp: this.up,
      localTp: this.tp,
      localDevice: this.device ?? 0,
    };
  },
  methods: {
    emitUpdate() {
      this.$emit("update", {
        sdate: this.localSdate,
        edate: this.localEdate,
        bwphotos: this.localBwphotos,
        colorphotos: this.localColorphotos,
        up: this.localUp,
        tp: this.localTp,
        device: this.localDevice,
      });
    },
    emitExport(type = "xlsx", lang = "ge") {
      this.$emit("export", {
        sdate: this.localSdate,
        edate: this.localEdate,
        bwphotos: this.localBwphotos,
        colorphotos: this.localColorphotos,
        up: this.localUp,
        tp: this.localTp,
        device: this.localDevice,
        format: type,
        lang,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.form-check-input {
  transform: scale(1.1);
  margin-top: -0.18rem !important;
}
</style>